<h2 mat-dialog-title>{{ data.title }}</h2>
<mat-dialog-content [formGroup]="form">
    <ng-container *ngFor="let field of data.fields">
        <mat-form-field appearance="fill" style="width: 100%">
            <mat-label>{{ field.label }}</mat-label>
            <input
                matInput
                [type]="field.type || 'text'"
                [formControlName]="field.key"
                [placeholder]="field.placeholder" />
        </mat-form-field>
    </ng-container>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-button [disabled]="isLoading" (click)="onCancel()">Cancel</button>
    <button mat-raised-button color="primary" [disabled]="form.invalid || isLoading" (click)="onSubmit()">
        <mat-spinner *ngIf="isLoading" diameter="18"></mat-spinner>
        <span *ngIf="!isLoading">{{ data.submitLabel || 'Create' }}</span>
    </button>
</mat-dialog-actions>
